// extracted by mini-css-extract-plugin
export default {"title":"_3PCKZe-1MteQZ9z34KBxA3","titleMFA":"_3ho7KVUXt-ZxIiBcqUSvOh","documentPreference":"gRnuIdu2yGBo20iRJA1p_"};